import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const channelSelector = createFeatureSelector<IState>('channel');
export const getChannelsSelector = createSelector(channelSelector, (state: IState) => state); 
export const getChannelSelector = createSelector(channelSelector, (state: IState) => state.selectedItem); 
